import { queryOptions } from "@tanstack/react-query";
import type { CommunityPostStatus, CommunityPostType } from "@/marketing/models/community";
import { communityAdminAPIClient } from "../communityAdminAPIClient";
import { COMMUNITY_KEYS } from "./keys";

export const COMMUNITY_QUERIES = {
  picks: () =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.picks(),
      queryFn: () => communityAdminAPIClient.listPicks(),
      staleTime: 30_000,
    }),
  guides: () =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.guides(),
      queryFn: () => communityAdminAPIClient.listGuides(),
      staleTime: 30_000,
    }),
  posts: (type: CommunityPostType, status?: CommunityPostStatus) =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.posts(type, status),
      queryFn: () => communityAdminAPIClient.listPosts(type, status),
      staleTime: 30_000,
    }),
  comments: (postId: string) =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.comments(postId),
      queryFn: () => communityAdminAPIClient.listPostComments(postId),
      staleTime: 30_000,
    }),
  trending: () =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.trending(),
      queryFn: () => communityAdminAPIClient.listTrending(),
      staleTime: 30_000,
    }),
  categories: () =>
    queryOptions({
      queryKey: COMMUNITY_KEYS.categories(),
      queryFn: () => communityAdminAPIClient.listCategories(),
      staleTime: 30_000,
    }),
};
